import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/loader-button-invert.svg")